import React from "react";
import warehouseImg from "../assets/warehouse.webp"; // Replace with your actual image path
import { motion } from "framer-motion";
import inventoryIcon from "../assets/inventory.svg";
import barcodeIcon from "../assets/barcode.svg";
import orderIcon from "../assets/order.svg";
import spaceIcon from "../assets/space.svg";
import multiIcon from "../assets/multi.svg";
import reportIcon from "../assets/report.svg";
// import "aos/dist/aos.css";
import mapImage from "../assets/map-image.png"; 
import iconMap from "../assets/icon-map.svg"; 
import uptimeIconn from "../assets/uptime-icon-grouped.svg"; // your grouped image (icon + line)
import { Helmet } from "react-helmet-async";

import brainImage from "../assets/brain-section.webp";
import { useNavigate } from 'react-router-dom'; 

import { useState, useEffect,useRef } from "react";
const WarehouseHero = () => {
   
const features = [
  {
    icon: inventoryIcon,
    title: "Real-Time Inventory Tracking",
    description: "Know exactly where every item is — reduce errors and out-of-stock risks.",
  },
  {
    icon: barcodeIcon,
    title: "Barcode & RFID Integration",
    description: "Fast, accurate scanning for seamless receiving, picking, and shipping.",
  },
  {
    icon: orderIcon,
    title: "Order & Shipment Management",
    description: "Speed up order fulfillment with automated workflows and smart routing.",
  },
  {
    icon: spaceIcon,
    title: "Warehouse Space Optimization",
    description: "Maximize layout efficiency with AI-powered space and bin management.",
  },
  {
    icon: multiIcon,
    title: "Multi-Warehouse Support",
    description: "Centralized control over all your warehouse locations from one dashboard.",
  },
  {
    icon: reportIcon,
    title: "Reports & Analytics",
    description: "Track KPIs, stock levels, and operational efficiency with visual dashboards.",
  },
];
const stats = [
  {
    title: "85% Faster Order Processing",
    description:
      "Accelerate fulfillment speeds and reduce delays with intelligent, automated workflows.",
    bg: "bg-[#EEF4FF]",
    image: mapImage,
  },
  {
    title: "99.9% Inventory Accuracy",
    description:
      "Maintain precise stock levels and eliminate costly inventory errors with real-time tracking.",
    bg: "bg-[#FDFDFD]",
    image: mapImage,
  },
  {
    title: "40% Reduction in Stockouts",
    description:
      "Ensure product availability and boost customer satisfaction with smarter inventory planning.",
    bg: "bg-[#FDFDFD]",
    image: mapImage,
  },
];
const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
          // const [isServicesOpen, setIsServicesOpen] = useState(false);
          // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
          // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
          };
        
          // const toggleServicesDropdown = () => {
          //   setIsServicesOpen(!isServicesOpen);
          // };
        
          // const toggleIndustriesDropdown = () => {
          //   setIsIndustriesOpen(!isIndustriesOpen);
          // };
        
          // const toggleCompanyDropdown = () => {
          //   setIsCompanyOpen(!isCompanyOpen);
          // };
    
      const [openDropdown, setOpenDropdown] = useState(null);
      const navRef = useRef(null);
    
      // Close dropdown on outside click
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (navRef.current && !navRef.current.contains(event.target)) {
            setOpenDropdown(null);
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, []);
    
      const toggleDropdown = (dropdown) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
      };
      
      const navigate = useNavigate();
     
      const handleClick = () => {
        navigate("/Contact#contact-section");
      };
        const [isOpen, setIsOpen] = useState(false);
              
                // const toggleDropdown = () => {
                //   setIsOpen((prev) => !prev);
                // };
          
          
                const [isServicesOpen, setIsServicesOpen] = useState(false);
            const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
            const [isCompanyOpen, setIsCompanyOpen] = useState(false);
          
            // Toggle functions for dropdowns
            const toggleServicesDropdown = () => {
              setIsServicesOpen(!isServicesOpen);
              setIsIndustriesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleIndustriesDropdown = () => {
              setIsIndustriesOpen(!isIndustriesOpen);
              setIsServicesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleCompanyDropdown = () => {
              setIsCompanyOpen(!isCompanyOpen);
              setIsServicesOpen(false);
              setIsIndustriesOpen(false); // Close other dropdowns
            };
                const [word, setWord] = useState('Today');
          
            useEffect(() => {
              const interval = setInterval(() => {
                setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
              }, 2000);
              return () => clearInterval(interval);
            }, []);

    
 const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
    <Helmet>
        <title>Warehouse Management System | Real-Time Inventory & Smart Warehouse.</title>
        <meta name="description" content="Optimize warehouse operations with LENTERA’s cloud-based Warehouse Management System. Streamline inventory, track shipments in real time, integrate barcode & RFID, maximize space, and boost order fulfillment efficiency."/>
        <meta name="keywords" content="Warehouse management system, WMS software, real-time inventory tracking, warehouse automation, barcode and RFID integration, order and shipment management."/>
      </Helmet>
    <section className="w-full bg-[#F8F8F8] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
{/* LEFT CONTENT */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <p className="text-[#212129] font-semibold text-sm mb-3 uppercase tracking-wider">
        Warehouse management
      </p>
      <h1 className="text-[#212129] text-[40px] md:text-[48px] leading-[52px] md:leading-[58px] font-extrabold mb-[24px]">
         Smarter Warehousing<br className="hidden lg:block" />
        Starts Here
      </h1>
      <p className="text-[#212129] text-[16px] md:text-[18px] leading-[28px] md:leading-[30px] max-w-[600px]">
        Streamline your inventory, optimize space, and track every movement — all in real time with our powerful Warehouse Management System.
      </p>
    </motion.div>

    {/* RIGHT IMAGE */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center lg:justify-end"
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
      viewport={{ once: true }}
    >
      <img
            src={warehouseImg}
            alt="Warehouse  Illustration"
            className="w-[280px] sm:w-[360px] md:w-[420px] lg:w-full max-w-[500px] h-auto object-contain"
          />
    </motion.div>

  </div>
</section>

    
  <section className="bg-gradient-to-b from-white to-[#f3f5ff] py-20 px-4 sm:px-6 lg:px-20 font-poppins">
      {/* Heading */}
      <div className="max-w-5xl mx-auto text-center mb-14">
        <div className="inline-block px-4 py-2 bg-[#e5e5e5] text-gray-700 text-sm font-semibold rounded-full mb-4">
          WHAT WE DO
        </div>
        <h2 className="text-[36px] md:text-[48px] font-extrabold text-[#1a1a1a] leading-tight">
          End-to-End Warehouse Control,<br className="hidden md:block" /> Simplified
        </h2>
        <p className="mt-4 text-lg md:text-xl text-gray-700 max-w-3xl mx-auto">
          Our cloud-based WMS empowers businesses to automate storage, improve accuracy,
          and gain full visibility of warehouse operations — from inbound to outbound.
        </p>

      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
        {features.map((item, index) => (
          <div
            key={index}
            className="bg-[#FFFFFF] rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 px-6 py-8 min-h-[280px] flex flex-col justify-between"
          >
            <div>
              <img
                src={item.icon}
                alt={item.title}
                className="w-12 h-12 mb-6"
              />
              <h3 className="text-lg font-semibold text-[#1e1e1e] mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  <section className="bg-[#F4F7FB] py-16 px-4 md:px-8 lg:px-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        
        {/* Left Content */}
        <div>
          {/* Badge */}
          <div className="inline-block px-4 py-2 bg-[#D6E4F0] text-gray-800 text-sm font-semibold rounded-full mb-4">
            OUR ADVANTAGES
          </div>

          {/* Heading */}
          <h2 className="text-[32px] md:text-[42px] font-extrabold text-[#1A1A1A] mb-4 leading-tight">
            Why Choose Us
          </h2>

          {/* Subheading */}
          <p className="text-lg text-[#555] mb-8">
            Empowering warehouses with speed, accuracy, and scalability you can trust.
          </p>

          {/* Uptime Icon + Text */}
          <div className="relative flex">
            {/* Uptime Icon and 3 Dots */}
            <div className="min-w-[60px] flex justify-center">
              <img
                src={uptimeIconn}
                alt="Uptime Icon"
                className="w-[48px] h-auto"
              />
            </div>

            {/* Text Block Aligned with Dots */}
            <div className="pl-4 space-y-6 pt-1">
              {/* Top Label */}
              <div>
                <h4 className="text-[#2A50FF] font-bold text-base">
                  99.99% system uptime
                </h4>
                <p className="text-sm text-[#333]">
                  Maximize layout efficiency with AI-powered space and bin management.
                </p>
              </div>

              {/* Bullet Points aligned with each dot */}
              <ul className="space-y-[35px] text-[#1A1A1A] text-base font-semibold pt-[10px]">
                <li>Used by 500+ warehouses globally</li>
                <li>100% customizable workflows</li>
                <li>24/7 expert support</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Right Brain Image */}
        <div className="flex justify-center lg:justify-end">
          <img
            src={brainImage}
            alt="Brain Illustration"
            className="w-full max-w-[460px] h-auto"
          />
        </div>
      </div>
    </section>
  
    <section className="bg-white py-16 px-4 md:px-8 lg:px-0">
  <div className="max-w-[1250px] mx-auto">
    {/* Top Section */}
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6 mb-12">
      <div>
        <span className="inline-block bg-[#EAF4FF] text-[#1A1A1A] text-sm font-semibold px-4 py-1 rounded-full mb-4">
          OUR ADVANTAGES
        </span>
        <h2 className="text-[30px] sm:text-[36px] md:text-[42px] lg:text-[48px] font-extrabold text-gray-900 leading-tight">
          Trusted by operations <br />
          teams across 10+ <br />
          countries
        </h2>
      </div>
      <p className="text-gray-700 text-base md:text-lg max-w-md">
        Our customers achieve faster fulfillment, reduced stockouts, and greater warehouse visibility — all within weeks.
      </p>
    </div>

    {/* Cards Section */}
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
      {/* Card 1 */}
      <div className="lg:col-span-6 bg-[#F0F6FF] rounded-3xl p-6 min-h-[260px] flex flex-col sm:flex-row items-center justify-between relative overflow-hidden">
        <div className="z-10 sm:max-w-[60%] w-full text-center sm:text-left mb-4 sm:mb-0">
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
            85% Faster Order Processing
          </h3>
          <p className="text-gray-600 text-base sm:text-[15px]">
            Accelerate fulfillment speeds and reduce delays with intelligent, automated workflows.
          </p>
        </div>
        <img
          src={mapImage}
          alt="Map Visual"
          className="z-0 w-24 md:w-32"
        />
        <img
          src={iconMap}
          alt="Map Icon"
          className="absolute bottom-0 left-0 w-10 sm:w-12 h-auto z-0"
        />
      </div>

      {/* Card 2 */}
      <div className="lg:col-span-3 bg-[#FAFAFA] rounded-3xl border border-gray-200 p-6 min-h-[260px] flex flex-col justify-center items-center text-center relative overflow-hidden">
        <div>
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
            99.9% Inventory Accuracy
          </h3>
          <p className="text-gray-600 text-base sm:text-[15px]">
            Maintain precise stock levels and eliminate costly inventory errors with real-time tracking.
          </p>
        </div>
        <img
          src={iconMap}
          alt="Map Icon"
          className="absolute bottom-0 left-0 w-10 sm:w-12 h-auto"
        />
      </div>

      {/* Card 3 */}
      <div className="lg:col-span-3 bg-[#FAFAFA] rounded-3xl border border-gray-200 p-6 min-h-[260px] flex flex-col justify-center items-center text-center relative overflow-hidden">
        <div>
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
            40% Reduction in Stockouts
          </h3>
          <p className="text-gray-600 text-base sm:text-[15px]">
            Ensure product availability and boost customer satisfaction with smarter inventory planning.
          </p>
        </div>
        <img
          src={iconMap}
          alt="Map Icon"
          className="absolute bottom-0 left-0 w-10 sm:w-12 h-auto"
        />
      </div>
    </div>
  </div>
</section>

    </>
  );
};

export default WarehouseHero;
